import type { FC } from 'react';
import { useState, useEffect } from 'react';

import Typography from 'components/Typography';

import { useLoadingStore } from 'store/useLoadingStore.ts';

import logoImg from 'assets/logo.svg';

import {
  LoadingContainer,
  LoadingContent,
  LoadingLogo,
  LoadingSpinner,
  LoadingSpinnerContainer,
} from './Loading.styled.ts';

const Loading: FC = () => {
  const { loading, message } = useLoadingStore();
  const [isVisible, setIsVisible] = useState(loading);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (loading) {
      setIsVisible(true);
      setIsAnimating(false);
    } else if (isVisible !== loading) {
      setIsAnimating(true);
      setTimeout(() => {
        setIsVisible(false);
        setIsAnimating(false);
      }, 500);
    }
  }, [loading]);

  if (!isVisible) return null;

  return (
    <LoadingContainer $isAnimating={isAnimating}>
      <LoadingLogo src={logoImg} alt="Logo" />

      <LoadingContent>
        <LoadingSpinnerContainer>
          <LoadingSpinner />
        </LoadingSpinnerContainer>

        <Typography type="Title" size="medium" style="light" color="#FEFEFE">
          {message}
        </Typography>
      </LoadingContent>
    </LoadingContainer>
  );
};

export default Loading;
